import { useEffect, useState } from 'react';

const UPLOAD_COMPLETE = 100;

export function UploadProgress({ inProgress }: { inProgress: boolean }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (inProgress) setProgress(0);

    const id = setInterval(() => {
      setProgress((prev) => {
        const next = prev + (UPLOAD_COMPLETE - prev) / 50;
        return next >= UPLOAD_COMPLETE ? UPLOAD_COMPLETE : next;
      });
    }, 100);

    return () => clearInterval(id);
  }, [inProgress]);

  useEffect(() => {
    if (!inProgress) setProgress(UPLOAD_COMPLETE);
  }, [inProgress]);

  return (
    inProgress && (
      <div className="tw-relative tw-flex tw-h-[72px] tw-w-[72px] tw-items-center tw-justify-center tw-rounded-[4px] tw-bg-[#C4C4C4]">
        <div
          className="tw-h-[24px] tw-w-[24px] tw-rounded-full tw-border-[2px] tw-border-solid tw-border-white tw-duration-300"
          style={{
            background: `conic-gradient(white 0% ${progress}%, transparent ${progress}% 100%)`,
          }}
        />
      </div>
    )
  );
}
